<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-toolbar dark color="primary" dense>
				<v-toolbar-title style="color: white">ゴム生地適合表</v-toolbar-title>
				<v-spacer></v-spacer>
				<template v-if="!$vuetify.breakpoint.xs">
					<v-btn dark v-if="authority" @click="openNewDialog" class="mr-2" color="primary">
						<v-icon>mdi-plus</v-icon>
						作成
					</v-btn>
				</template>
				<v-btn icon dark @click="showDialog = false" style="margin-right: 0.25rem" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="pa-2">
					<template v-if="$vuetify.breakpoint.xs">
						<v-row no-gutters justify="end">
							<v-btn dark v-if="authority" @click="openNewDialog" color="secondary">
								<v-icon>mdi-plus</v-icon>
								作成
							</v-btn>
						</v-row>
					</template>
					<div class="table-container mt-2">
						<v-data-table
							locale="ja-JP"
							:headers="headers"
							:items="rubbers"
							item-key="name"
							class="elevation-1"
							:mobile-breakpoint="240"
							disable-filtering
							disable-pagination
							disable-sort
							hide-default-footer
							no-data-text="データがありません。"
						>
							<template v-slot:item="{ item }">
								<tr class="clickable">
									<td>{{ item.name }}</td>
									<td>
										<template
											v-for="(rubber_customer_company, i) in item.rubber_customer_companies"
										>
											<div :key="i">
												<span>
													顧客企業 :{{ rubber_customer_company.customer_company.name }}/
												</span>
												<span>
													得意先コード:
													{{ rubber_customer_company.customer_company.customer_code }}/
												</span>
												<span>
													業種: {{ rubber_customer_company.customer_company.customer_code }}/
												</span>
												<span>
													タグ名: {{ rubber_customer_company.customer_company.customer_code }}
												</span>
												<span v-show="authority"
													>
													<!-- Todo 削除ダイアログ -->
													<v-btn
														@click="deleteRubberCustomerCompany(rubber_customer_company)"
														icon
														dark
														color="secondary"
														><v-icon>mdi-delete</v-icon></v-btn
													></span
												>
												<v-divider v-if="i < item.rubber_customer_companies.length - 1"></v-divider>
											</div>
										</template>
									</td>
								</tr>
							</template>
						</v-data-table>
						<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
					</div>
				</v-sheet>
			</v-sheet>
		</v-card>
		<RubberCustomerCompanyNewDialog :dialog.sync="showNewDialog" @create="setItems($event)" />
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import PaginationModule from "../../shared/PaginationModule.vue"
import RubberCustomerCompanyNewDialog from "./RubberCustomerCompanyNewDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		PaginationModule,
		RubberCustomerCompanyNewDialog,
	},
	data() {
		return {
			rubbers: [],
			headers: [
				{ text: "ゴム生地名", value: "name", width: "200px" },
				{ text: "顧客企業名", value: "", width: "600px" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			common,
			customer_companies: [],
			showNewDialog: false,
			rubber: {
				name: null,
			},
			authority: false,
		}
	},
	mounted() {
		this.fetchRubberCustomerCompanies(1)
	},
	methods: {
		deleteRubberCustomerCompany(rubber_customer_company) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber/rubber_customer_companies/${rubber_customer_company.id}`
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "削除しました。",
					})
					this.setItems(res.data.rubber)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setItems(rubber) {
			const index = this.rubbers.findIndex((item) => item.id === rubber.id)
			if (index >= 0) {
				// 要素が見つかった場合、引数のrubberを入れ替える
				this.rubbers.splice(index, 1, rubber)
			}
		},
		openNewDialog() {
			this.showNewDialog = true
		},
		fetchRubberCustomerCompanies(i) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber/rubber_customer_companies`
			axios
				.get(url, {
					headers,
					params: {
						page: i,
					},
				})
				.then((res) => {
					this.authority = res.data.authority
					this.rubbers = res.data.rubbers
					this.customer_companies = res.data.customer_companies
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			this.fetchRubberCustomerCompanies(i)
			const elements = document.getElementsByClassName("v-dialog--active")
			if (!elements || !elements.length) {
				return
			}
			elements[0].scrollTop = 0
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
